import { ApiServiceBase } from '../../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LocationGroupService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/product"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getAll() {
    return this.httpGet<any>(this.REFERENCE_PATH + "/locationgroup", null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }
  public getLocationGroupInOrderProductPoint() {
    return this.httpGet<any>(this.REFERENCE_PATH + "/locationgroup/orderProductPoint", null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }
}